// Map related action types
export const SET_GEOJSON_DATA = 'SET_GEOJSON_DATA';
export const SET_HEALTH_CLINIC_DATA = 'SET_HEALTH_CLINIC_DATA';
export const SET_EVENT_DATA = 'SET_EVENT_DATA';

// Filter related action types
export const CHANGE_SELECTED_STATE = 'CHANGE_SELECTED_STATE';
export const CHANGE_SELECTED_YEAR = 'CHANGE_SELECTED_YEAR';
export const CHANGE_SELECTED_INDICATOR = 'CHANGE_SELECTED_INDICATOR';
export const CHANGE_SELECTED_SUBGROUP = 'CHANGE_SELECTED_SUBGROUP';
export const CHANGE_SELECTED_COUNTRY = 'CHANGE_SELECTED_COUNTRY';
export const CHANGE_ISADM3 = 'CHANGE_ISADM3';
export const CHANGE_LEGEND = 'CHANGE_LEGEND';
export const CHANGE_YEAR_MONTH = 'CHANGE_YEAR_MONTH';
export const CHANGE_SELECTED_MAP_THEME = 'CHANGE_SELECTED_MAP_THEME';
export const CHANGE_MAP_LEGEND_MAX = 'CHANGE_MAP_LEGEND_MAX';
export const CHANGE_MAP_LEGEND_MIN = 'CHANGE_MAP_LEGEND_MIN';
export const CHANGE_DIFF_MAP = 'CHANGE_DIFF_MAP';

export const SET_YEAR_SLIDER_DATA = 'SET_YEAR_SLIDER_DATA';
export const SET_INDICATOR_DATA = 'SET_INDICATOR_DATA';
export const SET_MAP_SUBGROUPS_DATA = 'SET_MAP_SUBGROUPS_DATA';
export const SET_COUNTRY_DATA = 'SET_COUNTRY_DATA';

// API for fetching data
export const FETCH_DASHBOARD_DATA = 'FETCH_DATA';
export const FETCH_HEALTH_CLINIC_DATA = 'FETCH_HEALTH_CLINIC_DATA';
export const FETCH_EVENT_DATA = 'FETCH_EVENT_DATA';

// API related action types
export const API = 'API';
export const API_START = 'API_START';
export const API_END = 'API_END';
export const API_DENIED = 'API_DENIED';
export const API_ERROR = 'API_ERROR';


/* for messaging */
export const SHOW_WARNING ='SHOW_WARNING';
export const SHOW_ERROR ='SHOW_ERROR';
export const SHOW_INFO ='SHOW_INFO';
export const SHOW_STOP ='SHOW_STOP';
export const SHOW_SUCCESS ='SHOW_SUCCESS';
